"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Edit;

var _Edit = require("@adobe/react-spectrum-workflow/dist/Edit");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Edit(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Edit.A4uEdit, null));
}